import React from "react"
import styled from "styled-components"

import Input from "../components/Input"

const InputWrapper = styled.div`
  margin: 0 auto;
  max-width: 500px;
  padding: 0.5rem 0;

  input {
    margin: 0;
    padding-left: 40px;
    padding-right: 40px;
  }
`

const Datepicker = ({
  name,
  label,
  hideLabel,
  min,
  max,
  onChange
}) => {
  const today = new Date();
  const [date, setDate] = React.useState(today);
  const [isValid, setIsValid] = React.useState(true);

  const handleChange = (e) => {
    let newDate = new Date(e.target.value);
    if(isNaN(newDate.getDate())) {
      setIsValid(false);
    } else if (newDate < min || newDate > max) {
      setIsValid(false);
      setDate(newDate);
    } else {
      setIsValid(true);
      setDate(newDate);
      onChange?.(newDate);
    }
  };

  return (
    <InputWrapper>
      <Input
      {...{ name, label, hideLabel, isValid }}
        placeholder={label}
        prefix="datepicker-"
        onChange={handleChange}
        type="date"
        min={min.toISOString().split("T")[0]}
        max={max.toISOString().split("T")[0]}
        value={date.toISOString().split("T")[0]}
      />
    </InputWrapper>
  )
}

export default Datepicker
